import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "uppercase text-xl font-bold"
};
import GateButton from "@/modules/action-points/components/GateButtonConfirmation.vue";
import { PositionAreaEnum } from "@/modules/base/enums";
export default /*#__PURE__*/_defineComponent({
  __name: 'GateTrainingMF',
  props: {
    value: null
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(GateButton, _mergeProps(_ctx.$attrs, {
        color: _ctx.ColorEnum.Amber
      }), _createSlots({
        icon: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString(_unref(PositionAreaEnum).MF), 1)]),
        default: _withCtx(() => [_createTextVNode(" " + _toDisplayString(__props.value) + " ", 1)]),
        _: 2
      }, [_ctx.$slots.label ? {
        name: "label",
        fn: _withCtx(() => [_renderSlot(_ctx.$slots, "label")])
      } : undefined]), 1040, ["color"]);
    };
  }
});